export interface ReleaseType {
  releaseTypeId: string;
  name: string;
}
